const MIME_TO_EXTENSION = {
  'application/pdf': '.pdf',
  'application/zip': '.zip',
  'application/x-rar-compressed': '.rar',
  'application/vnd.rar': '.rar',
  'application/gzip': '.gz',
  'application/x-gzip': '.gz',
  'application/vnd.ms-excel': '.xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
  'text/csv': '.csv',
  'application/json': '.json',
  'text/plain': '.txt',
  'text/html': '.html',
  'text/xml': '.xml',
  'application/xml': '.xml',
  'application/rtf': '.rtf',
  'application/msword': '.doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
  'application/vnd.ms-powerpoint': '.ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': '.pptx',
  'image/png': '.png',
  'image/jpeg': '.jpg',
  'image/gif': '.gif',
  'image/webp': '.webp',
  'image/svg+xml': '.svg',
  'image/bmp': '.bmp',
  'image/heic': '.heic',
  'image/heif': '.heif',
  'image/tiff': '.tiff',
  'audio/mpeg': '.mp3',
  'audio/ogg': '.ogg',
  'audio/wav': '.wav',
  'video/mp4': '.mp4',
  'video/webm': '.webm',
  'video/ogg': '.ogv',
  'application/octet-stream': '.bin',
  'application/x-7z-compressed': '.7z',
  'application/x-tar': '.tar',
  'application/x-bzip2': '.bz2',
  'application/zstd': '.zst',
  'application/wasm': '.wasm',
  'font/woff': '.woff',
  'font/woff2': '.woff2',
  'font/otf': '.otf',
  'font/ttf': '.ttf',
} as const

type TypeMimeType = keyof typeof MIME_TO_EXTENSION

type TypeDownloadBlobFile = {
  blob: Blob
  mimeType: TypeMimeType | (string & {})
  name?: string
  onStatusChange?: (isDownloading: boolean) => void
}

function stripMimeParams(mimeType: string): string {
  return mimeType.split(';')[0].trim()
}

function getExtensionFromMime(mimeType: string): string {
  const base = stripMimeParams(mimeType) as TypeMimeType
  return MIME_TO_EXTENSION[base] ?? ''
}

export function downloadBlobFile({ blob, mimeType, name = 'download', onStatusChange }: TypeDownloadBlobFile): void {
	// For OLD browsers: It's necessary to create a new blob object with mime-type explicitly set otherwise only Chrome works like it should.
  const newBlob = new Blob([blob], { type: stripMimeParams(mimeType) })
  const extension = getExtensionFromMime(mimeType)
  const hasExtension = extension && name.endsWith(extension)
  const fileName = hasExtension ? name : `${name}${extension}`

  const url = URL.createObjectURL(newBlob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.click()

  setTimeout(() => URL.revokeObjectURL(url), 100)
  onStatusChange?.(false)
}
